module.exports = __webpack_public_path__ + "static/media/wesamlogo.a7df47b7.svg";